var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLongContainer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 18,
    viewBox: "0 0 71 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 17.09,
    transform: "translate(0.266602 0.0898438)",
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.017,
    y: 2.635,
    width: 0.5,
    height: 12,
    fill: "#DDD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.017,
    y: 2.635,
    width: 0.5,
    height: 12,
    fill: "#DDD"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 23.017,
    y: 2.635,
    width: 0.5,
    height: 12,
    fill: "#DDD"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 31.017,
    y: 2.635,
    width: 0.5,
    height: 12,
    fill: "#DDD"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 39.017,
    y: 2.635,
    width: 0.5,
    height: 12,
    fill: "#DDD"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 47.017,
    y: 2.635,
    width: 0.5,
    height: 12,
    fill: "#DDD"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 55.017,
    y: 2.635,
    width: 0.5,
    height: 12,
    fill: "#DDD"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 63.017,
    y: 2.635,
    width: 0.5,
    height: 12,
    fill: "#DDD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongContainer);
export default __webpack_public_path__ + "static/media/long_container.2f98ce4925d161c12a75836127e043ae.svg";
export { ForwardRef as ReactComponent };